<template>
    <div
        class="sbs-breadcrumbs"
        :class="themeClasses">
        <div
            v-if="withArrowBack"
            class="sbs-breadcrumbs__arrow-back"
            @click="emitBack">
            <!-- @slot Слот для иконки назад -->
            <slot name="arrowBack"></slot>
        </div>
        <div
            v-for="(item, i) in paths"
            :key="i"
            class="sbs-breadcrumbs__item">
            <!-- @slot Слот по-умолчанию. Доступны пропсы `index`, `item` и `paths` -->
            <slot
                v-bind="{
                    index: i,
                    item,
                    paths,
                }">
                <SbsLink
                    class="sbs-breadcrumbs__link"
                    v-bind="getLinkData({
                        index: i,
                        item,
                    })" />
            </slot>

            <!-- @slot Слот для разделителя ссылок. Доступны пропсы `index`, `item` и `paths` -->
            <slot
                name="divider"
                v-bind="{
                    index: i,
                    item,
                    paths,
                }">
                <SbsIcon
                    v-if="i !== paths.length - 1"
                    class="sbs-breadcrumbs__divider trs"
                    :iconName="divider"
                    :iconGroup="dividerGroup"
                    :iconSize="dividerSize"
                    :colorTheme="dividerTheme"
                    fixedWidth />
            </slot>
        </div>
    </div>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { isArrayContainsValue } from '../../utils/validators.js';
import { AllColors } from '../../utils/colors.js';
import {
    AllSizes,
    APP_SIZES,
} from '../../utils/sizes.js';
import {
    AllIconGroups,
    ICON_GROUPS,
} from '../icon/utils/consts.js';

/**
 * Компонент хлебных крошек, в котором использован компонент ссылки `SbsLink` как элемент навигации.
 * Используется для отображения навигационной цепочки пути до текущей страницы.
 */
export default {
    name: 'SbsBreadcrumbs',
    mixins: [themesMixin],
    methods: {
        getLinkData({ index, item }) {
            const isLastItem = index === this.paths.length - 1;

            return {
                colorTheme: AllColors.CURRENT_COLOR,
                disabled: isLastItem,
                hoverUnderline: this.hoverLinkUnderline,
                href: item.href,
                text: item.text,
                to: item.to,
                underlined: this.linkUnderlined && !isLastItem,
                underlineTheme: this.linkUnderlineTheme,
            };
        },
        emitBack() {
            this.$emit('back');
        },
    },
    props: {
        /**
         * Иконка для разделителя ссылок
         */
        divider: {
            type: String,
            default: 'slash-forward',
        },
        /**
         * Стиль (группа) иконки разделителя
         */
        dividerGroup: {
            type: String,
            default: AllIconGroups.REGULAR,
            validator: isArrayContainsValue(ICON_GROUPS),
        },
        /**
         * Размер иконки разделителя
         */
        dividerSize: {
            type: String,
            default: AllSizes.SMALL,
            validator: isArrayContainsValue(APP_SIZES),
        },
        /**
         * Тема (цветовые решения) для разделителя
         */
        dividerTheme: {
            type: String,
            default: AllColors.GRAY_DEEP,
        },
        /**
         * Тема (цветовые решения) для цвета нижнего подчеркивания ссылки при наведении
         */
        hoverLinkUnderline: {
            type: String,
            default: AllColors.CURRENT_COLOR,
        },
        /**
         * Массив роутов, каждый элемент должен содержать поля `text` и `to` либо `href`
         */
        paths: {
            type: Array,
            default: () => [],
        },
        /**
         * Определяет наличие нижнего подчеркивания у ссылки
         */
        linkUnderlined: {
            type: Boolean,
            default: true,
        },
        /**
         * Тема (цветовые решения) для цвета нижнего подчеркивания ссылки
         */
        linkUnderlineTheme: {
            type: String,
            default: AllColors.GRAY_LIGHT,
        },
        /**
         * Отображение слота arrowBack
         */
        withArrowBack: {
            type: Boolean,
            default: false,
        },

    },
};
</script>

<style lang="scss">
.sbs-breadcrumbs {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: baseline;

    @include typo-secondary-book;

    &__arrow-back {
        display: flex;
        align-self: center;
    }

    &__item {
        display: inline-flex;
        align-items: baseline;

        &:last-child {
            opacity: 0.7;
        }
    }

    &__link {
        word-wrap: break-word;
    }

    &__divider {
        margin-right: 5px;
        margin-left: 5px;
    }
}
</style>
